import { StyledContainer } from './PanelTitle.styled';

const PanelTitle = () => (
	<StyledContainer>
		<div>Мой гараж</div>
		<div>Управление вашим гаражом</div>
	</StyledContainer>
);

export { PanelTitle };
